import { render, staticRenderFns } from "./folderDetails.vue?vue&type=template&id=61d21150&scoped=true"
import script from "./folderDetails.vue?vue&type=script&lang=js"
export * from "./folderDetails.vue?vue&type=script&lang=js"
import style0 from "./folderDetails.vue?vue&type=style&index=0&id=61d21150&prod&lang=scss&scoped=true"
import style1 from "./folderDetails.vue?vue&type=style&index=1&id=61d21150&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d21150",
  null
  
)

export default component.exports